import { post, get, put, deleteApi } from './axiosFun';
// 关键字标签
export const tagPage = (params) => { return post(`/edu/key-tag/page`, params) };
export const tagList = (params) => { return post(`/edu/key-tag/list`, params) };

export const tagAdd = (params) => { return post(`/edu/key-tag/add`, params) };

export const tagEdit = (params) => { return put(`/edu/key-tag/edit`, params) };

export const tagDetails = (keyTagId) => { return get(`/edu/key-tag/detail/${keyTagId}`) };

export const tagRemove = (params) => { return deleteApi(`/edu/key-tag/remove`, params) };



// WEBPACK FOOTER //
// ./src/api/keys.js